import { InboundAssetRetrievalShipment, OutboundAssetRetrievalShipment } from "./assetRetrievalShipment";
import { Location } from "./location";
import { Organization } from "./organization";
import { User } from "./user";

export interface AssetRetrieval {
  employeeAddress: string;
  employeeAddressCity: string;
  employeeAddressCountry: string;
  employeeAddressState: string;
  employeeAddressTwo: string;
  employeeAddressZipCode: string;
  employeeEmail: string;
  employeeFirstName: string;
  employeeLastName: string;
  employeePhone: string;
  inboundAssetRetrievalShipment: InboundAssetRetrievalShipment;
  location: Location;
  manufacturer: string;
  model: string;
  orderNumber: string;
  organization: Organization;
  user: User;
  outboundAssetRetrievalShipment: OutboundAssetRetrievalShipment;
  priceInCents: number;
  serialNumber: string;
  state: string;
  uuid: string;
  insuranceOption?: number;
  labelsPrintedAt: string;
  packageOutToEmployeeAt: string;
  returnRecipientName: string;
  returnRecipientFirstName: string;
  returnRecipientLastName: string;
  returnRecipientCompany: string;
  returnRecipientEmail: string;
  returnRecipientAddress: string;
  returnRecipientAddressTwo: string;
  returnRecipientAddressCity: string;
  returnRecipientAddressState: string;
  returnRecipientAddressZipCode: string;
  returnRecipientAddressCountry: string;
  createdAt: string;
  virtualPickup: boolean;
  obfuscated?: boolean;
  addressUpdateReason: string;
  lastSyncedAt: string;
  orderCancelledAt: string;
  cancellationReason: string;
  canceledByEmail: string;
  assetRetrievalDevices: AssetRetrievalDevice[];
}

export interface AssetRetrievalDevice {
  id: number;
  manufacturer: string;
  model: string;
  serialNumber: string;
}

export enum BoxType {
  laptop = "laptop",
  laptopTablet = "laptop_tablet",
  laptopMobile = "laptop_mobile",
  tablet = "tablet",
  tabletMobile = "tablet_mobile",
  mobilePhone = "mobile_phone",
  desktop = "desktop",
  monitor = "monitor",
  bulk = "bulk",
}
